import store from '@/store/index.js'

export default {
    inserted(el, binding, vnode) {
        const { value } = binding;
        const options = store.state.permission && store.state.permission.options
        if (value && value instanceof Array && value.length > 0) {
            const permissionRoles = value;
            let hasPermission = options.some(role => {
                return permissionRoles.includes(role)
            })
            if(permissionRoles.includes(false)){
                hasPermission = !hasPermission;
            }
            if (!hasPermission) {
                el.parentNode && el.parentNode.removeChild(el)
            }
        }else{
            throw new Error(`need roles! Like v-permission="['admin','editor']"`)
        }
    }
}


// WEBPACK FOOTER //
// ./src/directive/permission/index.js